"use strict";
import { __require as l } from "./index.es226.js";
import { __require as c } from "./index.es327.js";
var i, u;
function d() {
  if (u) return i;
  u = 1;
  var e = /* @__PURE__ */ l(), n = c(), o = n([e("%String.prototype.indexOf%")]);
  return i = function(t, a) {
    var r = (
      /** @type {(this: unknown, ...args: unknown[]) => unknown} */
      e(t, !!a)
    );
    return typeof r == "function" && o(t, ".prototype.") > -1 ? n(
      /** @type {const} */
      [r]
    ) : r;
  }, i;
}
export {
  d as __require
};
//# sourceMappingURL=index.es227.js.map
